import { render, staticRenderFns } from "./AddBannerPopup.vue?vue&type=template&id=5144c998"
import script from "./AddBannerPopup.vue?vue&type=script&lang=js"
export * from "./AddBannerPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports